import React from "react";

import SignedContractsListContent from "../components/trips/signed-contracts-list";

const SignedContracts = () => {
  return <SignedContractsListContent />;
};

export default SignedContracts;
